import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSkylinerComponent } from './simple-icons-skyliner.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSkylinerComponent ],
    exports:      [ SimpleIconsSkylinerComponent ],
    bootstrap:    []
})
export class SimpleIconsSkylinerModule {}
